<ng-container *transloco="let t">
  <div class="pt-20 pb-16">

    @if (upcomingEvents.length ?? 0 > 0 || isFilterActive || isLoading) {
      <app-public-search-filter [filterBy]="['sports', 'country', 'length']"
                                [countries]="countries"
                                [sports]="sports"
                                [disablePastMonths]="true"
                                [lengthRanges]="lengthRanges"
                                [handleQueryParamsChange]="true"
                                [showLayoutButton]="false"
                                (onFilterChange)="filterChanged($event)">
      </app-public-search-filter>
      <app-loader [isLoading]="isLoading"></app-loader>

    @if (!(upcomingEvents.length ?? 0 > 0 ) && isFilterActive) {
        <app-empty-state [contentKeys]="['empty.state.profile.no.upcoming.events.title']"
                         [contentKeysSecondary]="['empty.state.profile.no.upcoming.events.search']"
                         [backgroundColor]="'white'" [paddingBottom]="'300px'"
                         [imgSrc]="'calendar-light.svg'"/>

    }
    @else {
      <app-user-event-grid-list [userEvents]="upcomingEvents ?? []"
                                [leftButtonKey]="'app.common.view.details'"
                                [rightButtonKey]="'app.common.my.registration'"
                                [type]="UserEventGridItemType.UPCOMING"
                                [showLeftActionButton]="false"
                                (scrolled)="loadMore()"
                                (onLeftButtonClickCallback)="goToEventDetailsPage($event)"
                                (onRightButtonClickCallback)="goToMyEntry($event)"
                                [languages]="languages"/>
    }

    } @else if (pastEvents.length > 0) {
      <app-empty-state [contentKeys]="['empty.state.profile.no.upcoming.events.title']"
                       [contentKeysSecondary]="['empty.state.profile.no.upcoming.events.returning.description']"
                       [backgroundColor]="'white'"
                       [imgSrc]="'calendar-light.svg'" [paddingBottom]="'300px'"
                       [buttonText]="'app.common.browse.events'" (onButtonClick)="goToEventCalendar()"/>
    } @else {
      <app-empty-state [contentKeys]="['empty.state.profile.no.registrations.title']"
                       [contentKeysSecondary]="['empty.state.profile.no.upcoming.events.description']"
                       [backgroundColor]="'white'"
                       [imgSrc]="'clipboard.svg'" [paddingBottom]="'300px'"
                       [buttonText]="'app.common.browse.events'" (onButtonClick)="goToEventCalendar()"/>
    }
  </div>

</ng-container>
